import { ref } from "vue";
import { Checkbox, CheckboxGroup } from "vant";
import "vant/lib/index.css";
import bus from "@/lib/bus";
import { platformStore } from "@/store/index";
import { Login, getUserInfo } from "@qcplay/platform-ui";
import { initGoogleId, initAppleId, initFacebookId } from "@/utils/utils";
import tracking from "@/utils/tracking";
export default {
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    Login
  },
  setup(props, context) {
    const store = platformStore();
    // 初始化SDK弹窗
    const showSDKLogin = async () => {
      // await initSDK()
      sdkRendering.value = true;
      showSdk.value = true;
    };

    //温馨提示弹窗
    const showTips = ref(false);

    // 用于格式化账号展示
    const maskPhoneNumberRegex = phoneNumber => {
      return phoneNumber;
      // const phoneStr = String(phoneNumber)

      // // 正则表达式解释:
      // // ^(\d{3}) : 匹配开头的3个数字，并将其捕获到分组1中
      // // \d{4}   : 匹配中间的4个数字 (这部分是我们想替换的)
      // // (\d{4})$ : 匹配结尾的4个数字，并将其捕获到分组2中
      // const regex = /^(\d{3})\d{4}(\d{4})$/
      // return phoneStr.replace(regex, "$1****$2")
    };
    // -----------sdk相关内容
    const sdkRendering = ref(false); //初始化完成
    const showSdk = ref(false); //sdk登录弹窗
    const onClose = () => {
      // 关闭登录弹窗
      showSdk.value = false;
      context.emit("closeLoginContainer");
    };
    const onFinish = async (token, data) => {
      // 登录完成后回调
      store.setAccessToken(token);
      store.setLoginWay(data.loginWay);
      await getUserInfo(token).then(res => {
        if (store.nowType != "zhcn") {
          store.setMobile(res.metadata.user_id);
        }
        store.setUserId(res.metadata.user_id);
      });
      showSdk.value = false;
      if (store.nowType == "zhcn") {
        const mobile = data.data.account || data.data.phone;
        store.setMobile(mobile);
      }
      tracking.trackEvent({
        status: "success"
      });
      bus.$emit("sendToken", token);
      bus.$emit("login");
    };
    const clientId = ref({
      google: initGoogleId(),
      //海外google id,app id配置
      apple: initAppleId(),
      //海外apple id,app id配置
      facebook: initFacebookId() //海外facebook id,app id配置
    }); //海外google id,app id配置
    const autoDownConfig = ref({
      account: true,
      sms: true
    });
    return {
      autoDownConfig,
      clientId,
      showSDKLogin,
      sdkRendering,
      onFinish,
      onClose,
      showSdk,
      maskPhoneNumberRegex,
      showTips
    };
  }
};